import { Component, inject } from '@angular/core';
import {
  Item,
  ItemActionResult,
  ItemProvider,
  ListViewProviderDirective,
  NtapGlobalConstants
} from '@ntap/core';
import { PrimeNGButtonNewItemViewActionComponent } from '@ntap/primeng';
import { Observable, first, map, tap } from 'rxjs';

// const FQAN_razina = Util.getFullAttrName('seup~klasa', 'razina');

@Component({
  selector: 'app-add-parent-to-klasa-action',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class AddParentToKlasaActionComponent extends PrimeNGButtonNewItemViewActionComponent {
  private myitemProvider = inject(ItemProvider);
  private listViewProvider = inject(ListViewProviderDirective);

  // protected override initDisabledObservable(): void {
  //   super.initDisabledObservable();
  //   this.isDisabled$ = this.myitemProvider.item$.pipe(
  //     map((item: any) => {
  //       // Dosje - razina 5
  //       return item[FQAN_razina] >= 5;
  //     })
  //   );
  // }

  protected override doExecuteWithItem(
    item: Item
  ): Observable<ItemActionResult> {
    this.action.isItemView = true;
    const mainTypeId: string = item['$mainType' as keyof typeof item] + '~id';
    this.addSubscription(
      this.myitemProvider.item$.pipe(first()).subscribe((olditem) => {
        (item as any)[NtapGlobalConstants.ATTR_$parentId] = (olditem as any)[
          mainTypeId
        ];
        (item as any)[NtapGlobalConstants.ATTR_$parent] = olditem;
      })
    );
    return super.doExecuteWithItem(item).pipe(
      tap(() => this.listViewProvider.refresh()),
      map(() => {
        return { result: {} } as ItemActionResult;
      })
    );
  }
}
